import ListingSkeleton from "./ListingSkeleton";
import createLoopingArray from "../../utils/createLoopingArray";
const Loading = () =>
  createLoopingArray(10).map((_, index) => (
    <ListingSkeleton key={`loading-skeleton-${index}`} />
  ));

export default Loading;
